module.exports = __webpack_public_path__ + "img/1756.799be323.gif";